import Phrase from '../../libs/translationsUtils/phrase'

const ContentQuote = ({ content, username, parentEl }) => {
  parentEl.className = 'content-quote-container'
  return username && (
    <div className='content-quote-username'>
      <span>{username}</span>
      &nbsp;
      <Phrase m='Common' p='wrote' />:
    </div>
  )
}

export default ContentQuote
